<template>
  <div class="ml-2">
    <base-rounded-button
      icon="mdi-target"
      :loading="isLoading"
      size="x-small"
      color="primary"
      :disabled="!geometry"
      @click="handleChangeValue"
      :tooltip="geometry ? $i18n.t('button.getElevation') : null"
    />
  </div>
</template>

<script>
import { getGeometryCentroid } from '@/assets/js/mapUtils';
import { GeoJSON } from 'ol/format';
import { call } from 'vuex-pathify';

export default {
  name: 'ElevationTrigger',
  props: {
    geometry: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    searchElevationGugik: call('search/searchElevationGugik'),
    async handleChangeValue() {
      if (!this.geometry) return;
      this.isLoading = true;
      const geometryOl = new GeoJSON().readGeometry(this.geometry, {
        dataProjection: this.geometry.crs?.properties?.name || this.$_config.defaultEpsg,
        featureProjection: 'EPSG:2180',
      });
      const centroid = getGeometryCentroid(geometryOl);
      try {
        /** Coordinates are inverted for EPSG:2180 */
        const r = await this.searchElevationGugik([centroid[1], centroid[0]]);
        if (r || r === 0) {
          this.$emit('changeValue', r);
        } else {
          this.$store.set('snackbar/PUSH_MESSAGE!', {
            message: this.$i18n.t('snackbar.notFoundElevation'),
          });
        }
      } catch (error) {
        console.error(error);
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('snackbar.notFoundElevation'),
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
